import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Maubaocao20 from "components/Tonghopbaocao/Maubaocao20/Maubaocao20.js";
export default function BCmau19() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Kết quả hoạt động của bến xe (Phụ lục XVI)",
            tabContent: <Maubaocao20 />,
          },
        ]}
      />
    </div>
  );
}
